<template>
  <div class="widget style1" :class="cardClass">
    <div class="row">
      <div class="col-xs-2">
        <i v-if="!showHeading" :class="icon" :style="{ fontSize: '4rem' }"></i>
      </div>
      <div class="col-xs-10 text-right">
        <span>{{ title }}</span>
        <h3 class="font-bold counter number" :style="{ padding: '0 8px' }">
          <span v-if="showCurrency" class="currency-prefix">Rs. {{ currentNumber | toCurrency }}</span>
          <span v-else>{{ currentNumber }}</span>
        </h3>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "HorizontalCard",
  data() {
    return {
      currentNumber: 0,
    };
  },
  watch: {
    stat(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.startAnimation();
      }
    },
  },
  props: {
    cardClass: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: null,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    stat: {
      type: Number,
      default: 0,
      required: true
    },
    showCurrency: {
      type: Boolean,
      default: false
    },
    animationDuration: {
      type: Number,
      default: 2000,
    },
  },
  computed: {
    showHeading() {
      return !this.icon;
    }
  },
  methods: {
    startAnimation() {
      let startTime;
      const step = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const progress = timestamp - startTime;
        this.currentNumber = Math.round((this.stat * progress) / this.animationDuration);
        if (progress < this.animationDuration) {
          requestAnimationFrame(step);
        } else {
          this.currentNumber = this.stat;
        }
      };
      requestAnimationFrame(step);
    },
  },
}
</script>

<style scoped>
.number {
  font-size: 1.8rem;
  transition: all 0.5s;
}

.currency-prefix {
  font-size: 1.8rem;
}
</style>

